<template>
  <div class="response-com content-container">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="" name="1">
        <template slot="title">
          <h2>{{title}}</h2>
        </template>
        <mavon-editor
            v-model="content"
            ref="md"
            @change="change"
            style="style"
            :defaultOpen="defaultOpen"
            :subfield="subfield"
            :toolbarsFlag="toolbarsFlag"
            :editable="editable"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import FormatCode from '../data/FormatCode.js'

export default {
  props: ['contentEditable', 'xml', 'title'],
  created () {
    this.contentEditable = false
    this.change()
    let formatCode = new FormatCode(this.xml)
    this.content += formatCode.getXmlCode()
  },
  data () {
    return {
      activeNames: ['1'],
      content: '',
      editable: true,
      subfield: true,
      toolbarsFlag: true,
      defaultOpen: null,
      style: ''
    }
  },
  methods: {
    change () {
      if (this.contentEditable) {
        this.subfield = true
        this.toolbarsFlag = true
        this.editable = true
        this.defaultOpen = null
        this.style = ''
      } else {
        this.subfield = false
        this.toolbarsFlag = false
        this.editable = false
        this.defaultOpen = 'preview'
        this.style = 'height: 100%'
      }
    }
  },
  watch: {
    contentEditable: {
      handler (val, oldval) {
        this.change()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/XmlContent.vue